import React from 'react';
import { StyledEntityAvatar } from './entity-layout.styles';

export const EntityLayoutAvatar = ({
    url, retinaUrl, videoUrl, retinaVideoUrl
}: { url?: string, videoUrl?: string, retinaUrl?: string, retinaVideoUrl?: string }) => (
    <StyledEntityAvatar url={url} retinaUrl={retinaUrl} videoUrl={videoUrl} retinaVideoUrl={retinaVideoUrl} />
);
